import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

export default function useResponsive(query, keyOrSize, startSize, endSize) {
  const theme = useTheme();

  // Handle custom size inputs
  const mediaUp = useMediaQuery(
    typeof keyOrSize === 'string'
      ? theme.breakpoints.up(keyOrSize)
      : `(min-width:${keyOrSize}px)`
  );

  const mediaDown = useMediaQuery(
    typeof keyOrSize === 'string'
      ? theme.breakpoints.down(keyOrSize)
      : `(max-width:${keyOrSize}px)`
  );

  const mediaBetween = useMediaQuery(
    typeof startSize === 'string' && typeof endSize === 'string'
      ? theme.breakpoints.between(startSize, endSize)
      : `(min-width:${startSize}px) and (max-width:${endSize}px)`
  );

  const mediaOnly = useMediaQuery(
    typeof keyOrSize === 'string'
      ? theme.breakpoints.only(keyOrSize)
      : `(min-width:${keyOrSize}px) and (max-width:${keyOrSize}px)`
  );

  if (query === 'up') {
    return mediaUp;
  }

  if (query === 'down') {
    return mediaDown;
  }

  if (query === 'between') {
    return mediaBetween;
  }

  if (query === 'only') {
    return mediaOnly;
  }

  return null;
}
